import z from "zod";

import { SIZES } from "@frontend/styles/constants";

import { YEAR_PICKER_LAYOUTS } from "./constants";

export const yearPickerDataSchema = z.object({
  value: z.coerce.number().int().optional(),
  min: z.coerce.number().int().optional(),
  max: z.coerce.number().int().optional(),
  placeholder: z.string().optional(),
  size: z.enum(SIZES).optional(),
  layout: z.enum(YEAR_PICKER_LAYOUTS).optional(),
  disabled: z
    .string()
    .optional()
    .transform((value) => value !== undefined && value !== "false"),
  arrow: z
    .string()
    .optional()
    .transform((value) =>
      value === undefined ? undefined : value !== "false",
    ),
});

export type YearPickerDataProps = z.infer<typeof yearPickerDataSchema>;
